import { FC, lazy } from 'react';

const Page = lazy(() => import('./page'));

export const DeveloperTools: FC = () => {
  return <Page />;
};
